module.exports = __webpack_public_path__ + "img/nodata.88c76aa6.png";